import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import PropTypes from 'prop-types';
import i18next from 'i18next';

export default class ServiceFilter extends Component {
  static propTypes = {
    filtersArray: PropTypes.array.isRequired,
    onFilterSelected: PropTypes.func.isRequired,
    onFilterClear: PropTypes.func,
    t: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedItem: ''
    }
  }

  getSeatName = rawSeat => {
    // console.log('Raw seat'.rawSeat);
    switch (rawSeat) {
      case 'SALON CAMA':
        return 'Salón Cama';
        break;
      case 'Salon Cama':
        return 'Salón Cama';
        break;
      case 'CLASICO':
        return 'Clásico';
        break;
      case 'Clasico':
        return 'Clásico';
        break;
      case 'Salon Sin Vent':
        return 'Salón Sin Vent';
        break;
      case 'SALON SIN VENT':
        return 'Salón Sin Vent';
        break;
      case 'Salon Preferente':
        return 'Salón Preferente';
        break;
      case 'SALON PREFERENTE':
        return 'Salón Preferente';
        break;
      case 'SALON':
        return 'Salón ';
        break;
      case 'Salon':
        return 'Salón ';
        break;
      case 'BIO BIO SUPERIOR':
        return 'Bio Bio Superior';
        break;
      default:
        return rawSeat;
        break;
    }
  };



  renderFilterItem = (option, onClick) => {
    const title = this.props.t('RESULTS_PAGE.' + option.title)
    const show = option.type === 'amenities' ? false : true
    return (
      <div className={'filter-category-box ' + option.align}>
        {show && (option.type === 'time' || !CommonService.isTrain()) ? (
          <div className="filter-category-title  pointer bold-text"
            onClick={() => this.setState({ selectedItem: this.state.selectedItem === title ? '' : title })}
          >
            {title}

            {this.state.selectedItem === title ?
              <img className="filter-category-title up-arrow" src="/images/ScrollDown-Arrow.svg" alt="" />
              :
              <img className="filter-category-title down-arrow" src="/images/ScrollDown-Arrow.svg" alt="" />
            }
          </div>
        ) : null}

        {this.state.selectedItem === title && (option.type == 'time' || !CommonService.isTrain())
          ? option.options.map((val, key) => {
            // console.log('Val######################', val);
            // if (val.value !== 'pet')
            return (
              <div
                key={key}
                className={
                  'filter-item pointer ' +
                  (val.active ? 'primary-text active bold-text ' : '') +
                  i18next.language
                }
                onClick={() => onClick(key)}
              >
                {val.icon ? (
                  <img
                    className="icon-size"
                    src={`/images/icons/icon-${val.icon + (val.active ? '-orange' : '')}.png`}
                  />
                ) : null}
                {val.trText
                  ? this.props.t('RESULTS_PAGE.' + val.trText)
                  : this.props.t(this.getSeatName(val.label))}
              </div>
            );
          })
          : null}
      </div>
    );
  };

  showClearFilter = () => {
    for (let f of this.props.filtersArray) {
      for (let o of f.options) {
        if (o.active) {
          return true;
        }
      }
    }
    return false;
  };

  clearFilter = () => {
    let filters = CommonService.copyObject(this.props.filtersArray);
    for (let f of filters) {
      for (let o of f.options) {
        o.active = false;
      }
    }
    this.props.onFilterClear(filters);
  };

  handlePetFilter = () => {
    const amenities = this.props.filtersArray.find(val => val.type === 'amenities')
    const pet = this.props.filtersArray.find(val => val.value === 'pet')
    console.log("amenities--------", amenities)

    this.props.onFilterSelected(pet, 2, 0)
  }


  renderPetFilter = (option, onClick) => {
    return <div>
      {option && option.type === 'amenities' && option.options.map((val, key) => {
        if (val.value === 'pet') {
          return (
            <div
              key={key}

              className='font10 primary-pet'
            >
              <strong>Mascota a bordo</strong>

              <img
                className="primary-pet-icon"
                // src={`/images/filter On-Button-Filter.svg+ (val.active ? '-orange' : '')}.svg`}
                src={`/images/filter/${val.active ? 'On' : 'Off'}-Button-Filter.svg`}
                onClick={() => onClick(key)}

              />

            </div>
          )
        }
      })}

    </div>

  }

  render() {
    let { t } = this.props;
    console.log('filters-------', this.props)

    return (
      <div className="common-service-filter filter-container pb-service-list-service-filter">
        <div className=" kupos-card">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className="filter-main-title font13" style={{ fontWeight: 700 }}>
              {t('RESULTS_PAGE.FILTERS')}
            </div>
            <div
              style={{
                height: 2,
                background: '#f7c938',
                width: 50,
                marginTop: 5,
              }}
            ></div>
          </div>



          <div>
            {this.props.filtersArray.map((val, key) => {
              return this.renderPetFilter(val, i => this.props.onFilterSelected(val, key, i));
            })}
          </div>

          <div className="filter-box font10">
            {this.props.filtersArray.map((val, key) => {
              return this.renderFilterItem(val, i => this.props.onFilterSelected(val, key, i));
            })}
          </div>
        </div>
        {this.showClearFilter() ? (
          <div className="remove-filter-box pointer font10" onClick={this.clearFilter}>
            <img src="/images/icons/close-window.svg" />
            {t('RESULTS_PAGE.REMOVE_FILTERS')}
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/ServiceFilter.js